export var STATUSES = {
  DRAFT: 'draft',
  COMPLETE: 'complete',
  DECLINED: 'declined'
};
export var TOP_NAVIGATION_HEIGHT = '60px';
export var CLIENTS = {
  WEB_APP: 'web_app',
  SMART_APP: 'smart_app'
};
export var SOURCES = {
  WEB_APP: 'web_app',
  SMART_APP: 'smart_app',
  EXTERNAL: 'external',
  SELF_SCREEN: 'self_screen'
};
export var TYPES = {
  CHECKBOX: 'checkbox',
  DROPDOWN_MULTISELECT: 'dropdown-multiselect',
  DATE: 'date',
  TEXT: 'text',
  NUMBER: 'number',
  COMMENT: 'comment',
  RADIOGROUP: 'radiogroup',
  HTML: 'html',
  DROPDOWN: 'dropdown',
  SELECT: 'select',
  SELECT_MULTIPLE: 'select_multiple'
};
export var singletonAnswers = ['Client Unable to Answer', 'Client Declined to Answer', 'Declined to answer', 'None of the above'];
//# sourceMappingURL=constants.js.map